import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  @Input()
  currentStep: number | undefined;

  @Input()
  countSteppers: number | undefined;

  @Input()
  error: boolean | undefined;

  get progressPercentage(): number {
    if(this.currentStep && this.countSteppers) {
      if(this.error) {
        return 99;
      }
      return (this.currentStep / this.countSteppers) * 100;
    }
    return 0;
  }

  constructor() { }

  ngOnInit(): void {
  }
}
